<template>
    <div id="warp">
        <headers :title='titles'></headers>
        <div>
            <ul>
                <li v-for='li,index in list'
                    @click='setclass(li,list)'
                    :class='{"active":li.isActive}'>
                    <span>{{li.name}}</span>
                    <span v-if='li.isActive'
                          class="icon_option"></span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
export default {
    data () {
        return {
            titles: '设置年级',
            grade_id: this.$route.query.grade_id,
            list: [{
                type: 1,
                name: '一年级',
                isActive: false
            }, {
                type: 2,
                name: '二年级',
                isActive: false
            }, {
                type: 3,
                name: '三年级',
                isActive: false
            }, {
                type: 4,
                name: '四年级',
                isActive: false
            }, {
                type: 5,
                name: '五年级',
                isActive: false
            }, {
                type: 6,
                name: '六年级',
                isActive: false
            }
            ]
        }
    },
    created () {
        if (this.grade_id) {
            this.list.forEach((m, n) => {
                if (m.type == this.grade_id) {
                    m.isActive = true
                }
            })
        }
    },
    components: {
        headers
    },
    methods: {
        setclass (ele, eles) {
            eles.forEach(function (e) {
                e.isActive = false;
            })
            ele.isActive = !ele.isActive;
            let grade_id = ele.type
            let that = this
            layer.open({
                title: '提示',
                diff: 'tea',
                content: "确定选这个年级吗",
                btn: ['确定', '取消'],
                yes: function () {
                    that.$http.post(API_URL_TASK_API + "/maths/send/quick/save_grade", { "grade_id": grade_id }).then(res => {
                        if (res.data.response === 'ok') {
                            layer.open({
                                content: '设置成功',
                                skin: 'msg',
                                time: 1
                            });
                            that.$router.replace('/sx/quick/selected');
                        }
                    })
                }
            })
        },
        goBack () {
            this.$router.go(-1)
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
#warp {
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
}
ul {
    position: relative;
    top: 100px / $ppr;
}

ul li {
    width: 300px / $ppr;
    display: inline-block;
    background: #f0f0f0;
    text-align: center;
    height: 80px / $ppr;
    line-height: 80px / $ppr;
    margin-left: 36px / $ppr;
    margin-top: 40px / $ppr;
    border-radius: 10px / $ppr;
    position: relative;
    .icon_option {
        display: inline-block;
        width: 30px / $ppr;
        height: 30px / $ppr;
        position: absolute;
        top: 8px / $ppr;
        left: 8px / $ppr;
        line-height: 0;
        background: url("./img/icon_option.png");
        background-size: cover;
    }
}

.active {
    background: #5e89ef;
    color: #fff;
}
</style>